import React, { Component } from 'react';
import { Redirect } from 'react-router';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';

import { Link } from 'react-router-dom';
import { Field } from 'redux-form';
import DateInput from 'components/DateInput';
import MultiSelectInput from 'components/MultiSelectInput';
import TextInput from 'components/TextInput';
import MoneyInput from 'components/MoneyInput';

import ModalRoot from 'components/Modal/ModalRoot';

const styles = theme => ({
  content: {
    backgroundColor: '#F4F8F9',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'scroll',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  titleContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  mainContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  leftContainer: {
    flexGrow: 3,
    paddingRight: 5,
  },
  rightContainer: {
    flexGrow: 1,
    paddingLeft: 5,
  },
  paper: {
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    background: '#FFFFFF',
    borderRadius: 4,
    // boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
  },
  libraryContainer: {
    height: '40vh',
  },
  paperTopPadding: {
    marginTop: 10,
  },
  title: {
    ...theme.Typography,
    color: '#044591',
  },
  bottomContainer: {
    display: 'flex',
    marginTop: theme.spacing(2),
    justifyContent: 'flex-end',
  },
  formControl: {
    marginTop: theme.spacing(),
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  },
  teste: {
    backgroundColor: '#ff0',
  },
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 26,
  }),
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing(0.25),
  },
});

export class New extends Component {
  constructor(props) {
    super(props);
    props.history.push('/dashboard');
    this.renderTitleContainer = this.renderTitleContainer.bind(this);
  }

  renderTitleContainer = () => {
    const { classes } = this.props;

    return (
      <div className={classes.titleContainer}>
        <Typography className={classes.title} variant="h6" gutterBottom>
          New McDonald's Campaign
        </Typography>
      </div>
    );
  };

  render() {
    const { auth, classes, handleSubmit, pristine, submitting } = this.props;

    return (
      <form
        onSubmit={handleSubmit}
        className={classes.content}
        noValidate
        autoComplete="off"
      >
        {auth.user == null && <Redirect to="/login" />}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography className={classes.title} variant="h6">
              {/* McDonald's */}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Paper className={classes.root} elevation={0}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <Field
                    label="Campaign Name"
                    name="name"
                    placeholder="Enter campaign name"
                    component={TextInput}
                    inputProps={{ maxLength: 100 }}
                    fullWidth
                    autoFocus
                    required
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    label="Brand"
                    name="brand"
                    component={TextInput}
                    inputProps={{ maxLength: 100 }}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    label="Description"
                    name="description"
                    component={TextInput}
                    inputProps={{ maxLength: 255 }}
                    fullWidth
                    multiline
                  />
                </Grid>
                <Grid item xs={4} lg={2}>
                  <Field
                    name="start"
                    label="Start Date"
                    component={DateInput}
                    placeholder="mm/dd/yyyy"
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4} lg={2}>
                  <Field
                    name="stop"
                    label="Stop Date"
                    component={DateInput}
                    placeholder="mm/dd/yyyy"
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4} lg={8} />
                <Grid item xs={5} lg={3}>
                  <Field
                    id="mediaType"
                    name="mediaType"
                    component={MultiSelectInput}
                    label="Media Type"
                    default={['tv']}
                    required
                    fullWidth
                    multiple
                  >
                    <MenuItem value="tv">TV</MenuItem>
                    <MenuItem value="radio">Radio</MenuItem>
                    <MenuItem value="web">Web</MenuItem>
                    <MenuItem value="venue">Venue</MenuItem>
                    <MenuItem value="other">Other</MenuItem>
                  </Field>
                </Grid>
                <Grid item xs={7} lg={9} />
                <Grid item xs={5} lg={3}>
                  <Field
                    label="Geography"
                    name="geography"
                    component={TextInput}
                    inputProps={{ maxLength: 150 }}
                    fullWidth
                    multiline
                  />
                </Grid>
                <Grid item xs={4} lg={2}>
                  <Field name="value" label="$ Value" component={MoneyInput} fullWidth />
                </Grid>
              </Grid>
            </Paper>
            <div className={classes.bottomContainer}>
              <Button
                variant="text"
                color="default"
                className={classes.button}
                component={Link}
                to="/dashboard/cms"
              >
                cancel
              </Button>
              <Button
                type="submit"
                variant="text"
                color="primary"
                className={classes.button}
                disabled={pristine || submitting}
              >
                create
              </Button>
            </div>
          </Grid>
        </Grid>
        <ModalRoot />
      </form>
    );
  }
}

export default withStyles(styles)(New);
